const number = (value, digits = 0) => new Intl.NumberFormat('es-AR', {
  minimumFractionDigits: digits,
  maximumFractionDigits: digits,
}).format(Number(value || 0));

export const formatFojaDateTime = (value) => !value ? 'Pendiente' : new Intl.DateTimeFormat('es-AR', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
}).format(new Date(value)).replace(',', ' ·');

export const formatFojaNumber = number;
export const formatFojaWeight = (value) => `${number(value, 2)} kg`;
export const formatFojaCurrency = (value) => new Intl.NumberFormat('es-AR', {
  style: 'currency', currency: 'ARS', minimumFractionDigits: 2,
}).format(Number(value || 0));
export const formatGuideCount = (value) => `${number(value)} ${Number(value) === 1 ? 'guía' : 'guías'}`;
